import { TableRow, styled, Typography, Link } from '@mui/material'
import { CommissionResponse } from 'store/commissions/commissions.types'
import { StyledTableCell } from '../commission-table-body/commission-table-body'

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.secondary.light,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}))

type CommissionTableRowProps = {
  commission: CommissionResponse
}

const CommissionTableRow = ({ commission }: CommissionTableRowProps) => {
  return (
    <StyledTableRow>
      {/* Invoice# Column */}
      <StyledTableCell sx={{ minWidth: 150 }} align="center">
        <Typography fontWeight={700} sx={{ color: 'InfoText' }}>
          <Link underline="none" sx={{ cursor: 'pointer' }}>
            {commission.invoiceNumber}
          </Link>
        </Typography>
      </StyledTableCell>

      {/* Company Column */}
      <StyledTableCell sx={{ minWidth: 120 }}>
        <Typography fontWeight={700} sx={{ color: 'InfoText' }}>
          {commission.companyName}
        </Typography>
      </StyledTableCell>

      {/* Rate Column - Hardcoded 10% */}
      <StyledTableCell sx={{ minWidth: 80 }}>
        <Typography fontWeight={700} sx={{ color: 'InfoText' }}>
          10%
        </Typography>
      </StyledTableCell>

      {/* Amount Column */}
      <StyledTableCell sx={{ minWidth: 150 }}>
        <Typography fontWeight={700} sx={{ color: 'InfoText' }}>
          {commission.amount.toFixed(2)}
        </Typography>
        <Typography
          sx={{
            color: 'InfoText',
            fontWeight: 300,
          }}
        >
          {commission.currency}
        </Typography>
      </StyledTableCell>

      {/* Commission Column */}
      <StyledTableCell sx={{ minWidth: 150 }}>
        <Typography fontWeight={700} sx={{ color: 'InfoText' }}>
          {commission.commission.toFixed(2)}
        </Typography>
        <Typography
          sx={{
            color: 'InfoText',
            fontWeight: 300,
          }}
        >
          {commission.currency}
        </Typography>
      </StyledTableCell>
    </StyledTableRow>
  )
}

export default CommissionTableRow

